export interface CanonicalConfiguration {
  checkIndex: number;
  checkValue: string;
  replace?: string;
  storeTo?: string;
}

export function getCanonicalPath(
  pathname: string,
  metaStore: any,
  configurations: Array<CanonicalConfiguration>
): string {
  const reverseOrderConfigurations = configurations.sort((x, y) => y.checkIndex - x.checkIndex);

  const urlParts = pathname.split('/');

  for (const configuration of reverseOrderConfigurations) {
    if (urlParts.length <= configuration.checkIndex + 2) {
      continue;
    }
    if (urlParts[configuration.checkIndex + 1] === configuration.checkValue) {
      if (configuration.storeTo) {
        metaStore[configuration.storeTo] = urlParts[configuration.checkIndex + 2];
      }

      if (!configuration.replace) {
        urlParts.splice(configuration.checkIndex + 2, 1);
      } else {
        urlParts[configuration.checkIndex + 2] = configuration.replace;
      }
    }
  }

  const actualPath = urlParts.join('/');
  pathname = actualPath;

  return pathname;
}
